import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/Index'
import Work from '@/view/Work'
import Home from '@/view/Home'
import EditUser from '@/view/EditUser'
import EditSong from '@/view/EditSong'
import Enter from '@/view/Enter'
import Claim from '@/view/Claim'
import Status from '@/view/Status'
import Photo from '@/view/Photo'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    }, {
      path: '/home',
      name: 'Home',
      component: Home
    }, {
      path: '/work',
      name: 'Work',
      component: Work
    }, {
      path: '/photo',
      name: 'Photo',
      component: Photo
    },{
      path: '/edituser',
      name: 'EditUser',
      component: EditUser
    }, {
      path: '/editsong',
      name: 'EditSong',
      component: EditSong
    }, {
      path: '/editsong/:id',
      name: 'EditSong',
      component: EditSong
    }, {
      path: '/status',
      name: 'Status',
      component: Status
    }, {
      path: '/status/:status',
      name: 'Status',
      component: Status
    }, {
      path: '/enter',
      name: 'Enter',
      component: Enter
    }, {
      path: '/claim',
      name: 'Claim',
      component: Claim
    }, {
      path: '*',
      name: 'Home',
      component: Home,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js